import produce from 'immer';
import { WALLET_CONNECTION_LIST_REQUEST } from '../../constants/log/walletConnectionLogConstants';

const initialState = {

};

const walletConnectionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case WALLET_CONNECTION_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default walletConnectionLogReducer;
